import React from 'react';
import { ImageUploadButton } from './ImageUploadButton';
export var ThumbnailPlaceholder = function (props) {
    var _a = props.multiple, multiple = _a === void 0 ? false : _a, handleFiles = props.handleFiles;
    return (React.createElement(ImageUploadButton, { handleFiles: handleFiles, multiple: multiple },
        React.createElement("div", { className: "rfu-thumbnail-placeholder" },
            React.createElement("svg", { width: "14", height: "15", viewBox: "0 0 14 15", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M14 8.998H8v6H6v-6H0v-2h6v-6h2v6h6z", fill: "#A0B2B8", fillRule: "nonzero" })))));
};
